import { getCopilotLayoutType } from '../framework/copilot';
import { renderRoot } from './root';
export function renderRootForNonQuartzFrameworkApp(reactElement, {
  strictMode = false,
  legacyRoot = true
} = {}) {
  let copilotLayoutType;
  try {
    copilotLayoutType = getCopilotLayoutType();
  } catch (_unused) {
    // There is no copilot layout type set so it remains undefined
  }
  renderRoot(reactElement, {
    strictMode,
    legacyRoot,
    copilotLayoutType
  });
}